// extracted by mini-css-extract-plugin
export default {"header":"VI67AM2502WiFrXrDVl5"};